import React from 'react'

// Material UI
import { Button } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// Style
import { makeStyles } from '@material-ui/core/styles'

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: "#f5f5f5",
        position: "fixed",
        width: "100%",
        bottom: -35,
    },
    addToCartButton: {
        bottom: -5,
        width: "100%",
        backgroundColor: "#003366",
    }
}));

const CartTotal = ({ handleSubTotal, handleCoupon, handleTaxCalculation, handleTotal, toggleDrawer, clientData, storeData }) => {


    const classes = useStyles()
    const styles = { alignItems: "baseline" }

    const { language } = clientData
    const { store } = storeData


    return (
        <Card className={classes.footer}>
            <CardContent>
                <Typography variant="h6">
                    <Grid justify="space-between" container style={styles}>
                        <Grid item>
                            {Language.CartSubTotal[language]}
                        </Grid>
                        <Grid item>
                            {handleSubTotal().toFixed(2)}$
                    </Grid>
                    </Grid>
                    {store.DISCOUNT_NAME &&
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                <Box color="red">{Language.CartCoupon[language]} {store.DISCOUNT_NAME}</Box>
                            </Grid>
                            <Grid item>
                                <Box color="red">- {handleCoupon().toFixed(2)}$</Box>
                            </Grid>
                        </Grid>
                    }
                    <Grid justify="space-between" container style={styles}>
                        <Grid item>
                            {Language.CartTax[language]}
                        </Grid>
                        <Grid item>
                            {handleTaxCalculation().toFixed(2)}$
                    </Grid>
                    </Grid>
                    <Grid justify="space-between" container style={styles}>
                        <Grid item>
                            <Box fontWeight="fontWeightBold">{Language.CartTotal[language]}</Box>
                        </Grid>
                        <Grid item>
                            <Box fontWeight="fontWeightBold">{handleTotal().toFixed(2)}$</Box>
                        </Grid>
                    </Grid>
                </Typography>
                <Button className={classes.addToCartButton} onClick={() => toggleDrawer(true)} variant="contained" size="large" >
                    <Typography style={{ color: "white" }}>{Language.CartProceedToCheckout[language]}</Typography>
                </Button>
                <br />
                <br />
            </CardContent>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        clientData: state.clientData,
        storeData: state.storeData,
    }
}

export default connect(mapStateToProps)(CartTotal)